import { useState } from 'react'
import { useSelector } from 'react-redux'
import CopyToClipboard from 'react-copy-to-clipboard'
import ReactTooltip from 'react-tooltip'
import {
  COPIED_CODE_MESSAGE,
  COPY_CODE_MESSAGE,
  COUPON_BUTTON_LABEL,
  COUPON_ERROR_MESSAGE,
  FIREBASE_EVENTS,
  PLAN_STATUS_KEY,
} from 'app-constants'
import { Button } from 'components'
import { useFirebaseEvent, useToaster } from 'hooks'
import { STATICS } from 'statics'
import { customerService } from 'services'
import './style.scss'

export function CouponButton() {
  const [couponCode, setCouponCode] = useState(null)
  const [isLoading, seIsLoading] = useState(false)
  const [iconTooltipText, seIconTooltipText] = useState(COPY_CODE_MESSAGE)
  const { sendEvent } = useFirebaseEvent()
  const { showErrorToast } = useToaster()
  const {
    selected: { contractStatus },
  } = useSelector(({ contract }) => contract)
  const { getCouponCode } = customerService()

  function handleIconClick() {
    seIconTooltipText(COPIED_CODE_MESSAGE)
  }

  function handleIconMouseLeave() {
    seIconTooltipText(COPY_CODE_MESSAGE)
  }
  async function handleGenerateCouponClick() {
    seIsLoading(true)
    sendEvent(FIREBASE_EVENTS.CLICK_ON_REFERER_FRIEND)

    try {
      const { data } = await getCouponCode()
      setCouponCode(data.code)
      sendEvent(FIREBASE_EVENTS.REFERER_FRIEND_SUCCESS)
    } catch (error) {
      sendEvent(FIREBASE_EVENTS.REFERER_FRIEND_ERROR)
      showErrorToast(COUPON_ERROR_MESSAGE)
      console.error(error)
    } finally {
      seIsLoading(false)
    }
  }

  function renderGenerateButton() {
    return (
      <Button className='generate-button' onClick={handleGenerateCouponClick} isLoading={isLoading}>
        {COUPON_BUTTON_LABEL}
      </Button>
    )
  }

  function renderCopyCodeButton() {
    return (
      <CopyToClipboard text={couponCode}>
        <Button
          className='copy-button'
          onClick={handleIconClick}
          onMouseLeave={handleIconMouseLeave}
          data-for='barcode-tip'
          data-tip={iconTooltipText}
        >
          <div className='text-coupon'>{couponCode}</div>
          <div>
            <STATICS.COPY />
            <ReactTooltip id='barcode-tip' getContent={() => iconTooltipText} />
          </div>
        </Button>
      </CopyToClipboard>
    )
  }

  if (contractStatus === PLAN_STATUS_KEY.ST_CONT_CANCELADO) return null

  return (
    <div className='coupon-button-container'>
      {!couponCode ? renderGenerateButton() : renderCopyCodeButton()}
    </div>
  )
}
